import { addNotification } from './add-notification';
export const addNotificationByType = (notificationDetails, type, internalActions) => {
    var _a, _b;
    const { id, messages, title, iconName, autoDismiss, closeButton, actionButton } = notificationDetails;
    const notification = {
        id,
        title,
        messages,
        iconName,
        autoDismiss: autoDismiss !== null && autoDismiss !== void 0 ? autoDismiss : true,
        type,
        internalActions,
        closeButton: Object.assign(Object.assign({}, closeButton), { show: (_a = closeButton === null || closeButton === void 0 ? void 0 : closeButton.show) !== null && _a !== void 0 ? _a : true }),
        actionButton: Object.assign(Object.assign({}, actionButton), { show: (_b = actionButton === null || actionButton === void 0 ? void 0 : actionButton.show) !== null && _b !== void 0 ? _b : false })
    };
    addNotification(notification);
};
